import React, { useState } from 'react';
import styled from 'styled-components';
import {
  Button,
  Caption,
  Card,
  PhoneIcon,
  MailIcon,
  BodyLink,
  Subtitle,
  Stack
} from '@kvdbil/components';
import { Collapse } from 'react-collapse';
import { useTranslation } from '~/Locale';
import {
  formatPhoneNumber,
  formatPhoneNumberForLink
} from '~/helpers/phoneNumber';

const Container = styled(Stack)`
  padding: 1.5rem 1rem;
  text-align: center;
`;

const PhoneAndEmailWrapper = styled.div`
  display: grid;
  width: fit-content;
  margin: 0 auto;
  row-gap: 1rem;
`;

const ContactItem = styled.div`
  display: grid;
  grid-template-columns: max-content max-content;
  column-gap: 1rem;
  align-items: center;

  svg {
    font-size: 1.5rem;
  }
`;

const StyledBodyLink = styled(BodyLink)`
  color: ${({ theme }) => theme.colors.info.dark};
`;

const NoBankIdInfo = () => {
  const { t } = useTranslation();
  const [showContactInfo, setShowContactInfo] = useState(false);

  return (
    <Stack spacing={2}>
      <Button
        variant="flat"
        color="info"
        onClick={() => setShowContactInfo(s => !s)}
      >
        {t(`Don't have BankID`)}
      </Button>
      <Collapse isOpened={showContactInfo}>
        <Card>
          <Container>
            <Subtitle as="h3">{t('Are you missing BankID?')}</Subtitle>
            <Caption>
              {t('Please contact our customer service and we will help you.')}
            </Caption>
            <PhoneAndEmailWrapper>
              <ContactItem>
                <PhoneIcon />
                <StyledBodyLink
                  as="a"
                  href={`tel:${formatPhoneNumberForLink(
                    t('CUSTOMER_CONTACT_PHONE')
                  )}`}
                  target="_blank"
                >
                  {formatPhoneNumber(t('CUSTOMER_CONTACT_PHONE'))}
                </StyledBodyLink>
              </ContactItem>
              <ContactItem>
                <MailIcon />
                <StyledBodyLink
                  as="a"
                  href={`mailto:${t('CUSTOMER_CONTACT_MAIL')}`}
                  target="_blank"
                >
                  {t('CUSTOMER_CONTACT_MAIL')}
                </StyledBodyLink>
              </ContactItem>
            </PhoneAndEmailWrapper>
          </Container>
        </Card>
      </Collapse>
    </Stack>
  );
};

export default NoBankIdInfo;
